import { ISettingsState } from './settings.state.interface';


export const SETTINGS_STATE_DEFAULTS: ISettingsState = {
  defaultProfileSettings: null,
};
